import { DashboardProvider } from 'contexts/DashboardContext'
import DashboardContextSandbox from './Sandbox'

export default function DashboardContextSandboxWrapper() {
  return (
    <DashboardProvider>
      <DashboardContextSandbox />
    </DashboardProvider>
  )
}